export enum AttachmentType {
  Unknown = 0,
  ReceiptFundTree,
  ReceiptGiftTree,
  CertificateGift,
  CertificateBulk,
  CertificateBulkSend,
  ReceiptFundPlanting,
  InvoiceFundPlanting,
  InvoiceGiftTree,
  ReceiptRegistryGift,
  GrabOneFundTree,
  TaxReceipt,
  CertificatesPackaged
}

export const ATTACHMENT_TYPE_VALUES = {
  [AttachmentType.Unknown]: 'Unknown',
  [AttachmentType.ReceiptFundTree]: 'Receipt (donation)',
  [AttachmentType.ReceiptGiftTree]: 'Receipt (gift)',
  [AttachmentType.CertificateGift]: 'Gift certificate',
  [AttachmentType.CertificateBulk]: 'Gift certificate (bulk)',
  [AttachmentType.CertificateBulkSend]: 'Gift certificate (bulk)',
  [AttachmentType.ReceiptFundPlanting]: 'Receipt (donation)',
  [AttachmentType.InvoiceFundPlanting]: 'Invoice (donation)',
  [AttachmentType.InvoiceGiftTree]: 'Invoice (gift)',
  [AttachmentType.ReceiptRegistryGift]: 'Receipt (registry)',
  [AttachmentType.GrabOneFundTree]: 'Grabone',
  [AttachmentType.TaxReceipt]: 'Tax certificate',
  [AttachmentType.CertificatesPackaged]: 'Certificates'
}

/**
 * Maps purchase types to their expected receipt/invoice attachment types.
 * This handles the fact that purchase types and attachment types don't align numerically.
 *
 * Note: For bulk gifts and funded plantings, multiple attachment types are possible
 * depending on payment method (receipt vs invoice).
 */
export const getReceiptAttachmentTypesForPurchase = (
  purchaseType: number
): AttachmentType[] => {
  switch (purchaseType) {
    case 1: // PurchaseType.FundedTree
      return [AttachmentType.ReceiptFundTree]
    case 2: // PurchaseType.GiftedTree
      return [AttachmentType.ReceiptGiftTree]
    case 3: // PurchaseType.BulkGifted
      return [AttachmentType.ReceiptGiftTree, AttachmentType.InvoiceGiftTree]
    case 4: // PurchaseType.FundedPlanting
      return [
        AttachmentType.ReceiptFundPlanting,
        AttachmentType.InvoiceFundPlanting
      ]
    case 5: // PurchaseType.RegistryGift
      return [AttachmentType.ReceiptRegistryGift]
    default:
      return []
  }
}
